export enum AncillariesType {
  None = 0,
  Baggage = 1,
  Seat = 2,
  Meal = 3,
  Priority = 4,
  Taxi = 5,
  Lounge = 6,
}
